import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UsersService } from '@app/api/api';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { EditUserInfoComponent } from './component/edit-user-info/edit-user-info.component';

@Component({
  selector: 'meu-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.scss'],
})
export class ManageUsersComponent implements OnInit {
  keyUp = new Subject<KeyboardEvent>();
  lstUsers: any[] = [];
  displayedColumns: string[] = [
    'index',
    'id_code',
    'full_name',
    'gender',
    'email',
    'phone',
    'action',
  ];
  total: any;
  pageSize = 10;
  pageIndex = 1;
  filter: any = '';

  pageSizeOptions: number[] = [5, 10, 20, 100];

  constructor(
    public dialog: MatDialog,
    private toastr: ToastrService,
    private usersService: UsersService
  ) {}

  ngOnInit() {
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(500)
      )
      .subscribe((value) => {
        this.pageIndex = 1;
        this.pageSize = 10;
        this.filter = 'full_name|email|phone|company_tax_code@=*' + value;
        this.getListUsers();
      });
    this.getListUsers();
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getListUsers();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
    this.pageIndex = 1;
    this.getListUsers();
  }

  getListUsers() {
    this.usersService
      .apiUsersGet(this.filter, '', this.pageIndex, this.pageSize)
      .subscribe((res) => {
        if (res.success) {
          this.total = res.data.total;
          // this.pageIndex = res.data.pageIndex;
          // this.pageSize = res.data.pagesize;
          this.lstUsers = res.data.collection;
        } else {
          this.toastr.error(res.message);
        }
      });
  }

  openModalUser(id) {
    const dialogRef = this.dialog.open(EditUserInfoComponent, {
      width: '1200px',
      maxWidth: '96vw',
      maxHeight: '92vh',
      data: { id: id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getListUsers();
    });
  }
}
